import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormProdutoServicoTipoObjeto from "../../pages/ProdutoServicoTipoObjeto/FormProdutoServicoTipoObjeto";
import Permissao from "../../controllers/Permissao";
import ProdutoServicoTipoObjetoService from "../../services/ProdutoServicoTipoObjetoService";

export default class SelectProdutoServicoTipoObjeto extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(84));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Tipo de Objeto',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormProdutoServicoTipoObjeto,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idCombustivel) {
                        this.handleOpenSearch(null, response.data?.idCombustivel);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        ProdutoServicoTipoObjetoService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}